module.exports = __webpack_public_path__ + "img/clipboard-medical.ab017d40.svg";